
export default {
  name: 'FilterCategory',
  // eslint-disable-next-line vue/require-prop-types
  props: ['dataFilter', 'buttonLoadMore', 'limit', 'textValue', 'textName', 'keyFilter'],
  data() {
    return {
      listData: [],
      listValue: [],
      showListFilter: true,
      loadMore: false,
      itemValue: 'id',
      itemName: 'value'
    }
  },
  created() {
    if (this.textValue) {
      this.itemValue = this.textValue
    }
    if (this.textName) {
      this.itemName = this.textName
    }
  },
  methods: {
    resetValidate(ref) {
      this.$refs.accountForm.fields.find((f) => f.prop === ref).clearValidate()
      this.accountForm.errors[ref] = ''
    },
    checkShow(index) {
      if (this.buttonLoadMore !== true) return true
      if ((this.loadMore === false) && (index >= this.limit)) return false
      return true
    },
    changeToLink(link) {
      this.$router.push(link)
    }
  }
}
